import { Injectable } from '@angular/core';

@Injectable()
export class ListEffects {
  constructor() {}
}
